import { useState } from "react";

const testimonials = [
  {
    id: 1,
    name: "Ana Paula Ferreira",
    role: "Gerente de Loja — São Paulo, SP",
    text: "Depois do Método CAT, minha equipe bateu a meta pela primeira vez em 8 meses. A forma como a Gleice explica o comportamento do consumidor mudou completamente a abordagem dos meus vendedores. Resultado real, do primeiro mês.",
    rating: 5,
    initials: "AP",
    color: "bg-[#c4a882]",
  },
  {
    id: 2,
    name: "Carla Mendonça",
    role: "Empreendedora — Belo Horizonte, MG",
    text: "Eu vendia bem, mas não sabia o porquê. Com o CAT entendi toda a lógica por trás das minhas vendas e consegui replicar o que funcionava. Faturei 40% a mais no mês seguinte ao curso.",
    rating: 5,
    initials: "CM",
    color: "bg-[#8c9e8a]",
  },
  {
    id: 3,
    name: "Renata Souza",
    role: "Consultora de Moda — Rio de Janeiro, RJ",
    text: "O módulo de WhatsApp Business sozinho já valeu o investimento. Aprendi a criar scripts que realmente convertem e automatizei boa parte do meu atendimento. Hoje atendo o dobro de clientes com menos esforço.",
    rating: 5,
    initials: "RS",
    color: "bg-[#a88c8c]",
  },
  {
    id: 4,
    name: "Juliana Costa",
    role: "Vendedora Autônoma — Curitiba, PR",
    text: "Tinha medo de usar IA no meu negócio, achava que era complicado. A Gleice mostrou ferramentas simples e práticas que qualquer pessoa consegue aplicar. Hoje uso todo dia e não consigo mais imaginar trabalhar sem.",
    rating: 5,
    initials: "JC",
    color: "bg-[#8a8ca0]",
  },
  {
    id: 5,
    name: "Marcela Pinheiro",
    role: "Supervisora de Varejo — Brasília, DF",
    text: "O Método CAT me deu linguagem e ferramentas para liderar minha equipe com mais segurança. As planilhas de bônus são incríveis — organizei tudo que era caótico em questão de dias.",
    rating: 5,
    initials: "MP",
    color: "bg-[#b8a070]",
  },
  {
    id: 6,
    name: "Fernanda Lima",
    role: "Diretora Comercial — Fortaleza, CE",
    text: "Fiz vários cursos de vendas na minha vida, mas nenhum tão direto ao ponto quanto este. Conteúdo denso, aplicável, sem enrolação. A Gleice entrega com generosidade e clareza que poucos professores têm.",
    rating: 5,
    initials: "FL",
    color: "bg-[#7a9090]",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setActive((c) => (c + 1) % testimonials.length);

  const visible = [
    testimonials[active % testimonials.length],
    testimonials[(active + 1) % testimonials.length],
    testimonials[(active + 2) % testimonials.length],
  ];

  return (
    <section className="py-24 px-6 md:px-16 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.35em] uppercase text-gray-400 mb-3">Resultados Reais</p>
          <h2 className="text-3xl md:text-4xl font-light tracking-tight text-black mb-4">
            Quem fez o Método CAT
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            Mais de 3.000 profissionais do varejo já transformaram seus resultados com a metodologia da Gleice Lyra.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {visible.map((t, i) => (
            <div
              key={`${t.id}-${i}`}
              className={`bg-white p-8 flex flex-col justify-between transition-all duration-500 ${i === 1 ? "md:-translate-y-3" : ""}`}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <i key={s} className="ri-star-fill text-[#c9a84c] text-sm"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 text-sm leading-relaxed mb-8 flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${t.color} flex-shrink-0`}>
                  <span className="text-white text-xs font-semibold tracking-wide">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-black tracking-wide">{t.name}</p>
                  <p className="text-[11px] text-gray-400 tracking-wide">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-6">
          <button
            onClick={prev}
            className="w-10 h-10 border border-gray-300 flex items-center justify-center text-gray-500 hover:border-black hover:text-black transition cursor-pointer"
          >
            <i className="ri-arrow-left-line text-sm"></i>
          </button>

          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`cursor-pointer transition-all duration-300 ${
                  i === active ? "w-8 h-[2px] bg-black" : "w-3 h-[2px] bg-gray-300"
                }`}
              />
            ))}
          </div>

          <button
            onClick={next}
            className="w-10 h-10 border border-gray-300 flex items-center justify-center text-gray-500 hover:border-black hover:text-black transition cursor-pointer"
          >
            <i className="ri-arrow-right-line text-sm"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mt-20 pt-16 border-t border-gray-200">
          {[
            { value: "+3.000", label: "Alunos formados" },
            { value: "98%", label: "Recomendam o curso" },
            { value: "40%", label: "Aumento médio em vendas" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl font-light text-black tracking-tight mb-2">{stat.value}</p>
              <p className="text-xs tracking-widest uppercase text-gray-400">{stat.label}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
